/** Pilot launch. Set REACT_APP_*=true to turn a paused feature back on. */
export const SCAN_ALERTS_PAUSED = process.env.REACT_APP_SCAN_ALERTS !== "true";
export const BLOOD_SOS_PAUSED = process.env.REACT_APP_BLOOD_SOS !== "true";
/** In-app Rah-Veer reward tracking and claim steps; informational copy stays visible when paused. */
export const RAH_VEER_FLOW_PAUSED = process.env.REACT_APP_RAH_VEER !== "true";
